import React from 'react'

export default () => <div className="Blog">Home</div>
